import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "form"]

  connect() {
    console.log("Preview sample controller connected")
  }

  updatePreview(event) {
    const studentId = event.target.value
    const studentName = event.target.selectedOptions[0].getAttribute('data-name')
    const studentClass = event.target.selectedOptions[0].getAttribute('data-class')
    
    console.log(`Selected student: ${studentName} (${studentClass})`)
    
    // Update form with selected student ID
    if (this.hasFormTarget) {
      const hiddenInput = this.formTarget.querySelector('input[name="student_id"]')
      if (hiddenInput) {
        hiddenInput.value = studentId
      } else {
        // Create hidden input if it doesn't exist
        const input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'student_id'
        input.value = studentId
        this.formTarget.appendChild(input)
      }
    }
  }

  async generatePreview(event) {
    event.preventDefault()
    
    if (!this.hasContainerTarget) return
    
    // Show loading state
    this.showLoading()
    
    try {
      const formData = new FormData(this.formTarget)
      const response = await fetch(this.formTarget.action, {
        method: 'POST',
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'text/html'
        }
      })
      
      if (response.ok) {
        const html = await response.text()
        this.containerTarget.innerHTML = html
      } else {
        this.showError('Erreur lors de la génération de l\'aperçu')
      }
    } catch (error) {
      console.error('Preview generation error:', error)
      this.showError('Erreur de connexion')
    }
  }

  showLoading() {
    this.containerTarget.innerHTML = `
      <div class="py-12 text-center">
        <svg class="animate-spin mx-auto h-8 w-8 text-blue-500 mb-4" fill="none" viewBox="0 0 24 24">
          <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
          <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
        </svg>
        <p class="text-sm text-gray-500">Génération de l'aperçu en cours...</p>
      </div>
    `
  }

  showError(message) {
    this.containerTarget.innerHTML = `
      <div class="py-12 text-center">
        <svg class="mx-auto h-8 w-8 text-red-500 mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
        </svg>
        <p class="text-sm text-red-500">${message}</p>
        <button type="button" 
                data-action="click->preview-sample#retry"
                class="mt-2 text-sm text-blue-600 hover:text-blue-800">
          Réessayer
        </button>
      </div>
    `
  }

  retry() {
    const generateButton = this.element.querySelector('[data-action*="generatePreview"]')
    if (generateButton) {
      generateButton.click()
    }
  }
} 